export var USER_AGENT = "user-agent";
export var X_AMZ_USER_AGENT = "x-amz-user-agent";
export var SPACE = " ";
export var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;